import { render, staticRenderFns } from "./UserEditPasswordModal.vue?vue&type=template&id=3d122b98"
import script from "./UserEditPasswordModal.vue?vue&type=script&lang=js"
export * from "./UserEditPasswordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports